/* eslint no-inline-comments: 0 */

const List = () => import( /* webpackChunkName: "group-projects" */ `./list.vue` );
const Add = () => import( /* webpackChunkName: "group-projects" */ `./add.vue` );
const Edit = () => import( /* webpackChunkName: "group-projects" */ `./edit.vue` );
const Import = () => import( /* webpackChunkName: "group-projects" */ `./import.vue` );
const ProjectSuggestionDetail = () => import( /* webpackChunkName: "group-projects" */ `./project-suggestion-detail.vue` );
const Settings = () => import( /* webpackChunkName: "group-projects" */ `./settings.vue` );

export default {
	path: `projects`,
	children: [
		{
			path: ``,
			name: `list-projects`,
			component: List,
			meta: {
				title: `Projects`
			}
		},
		{
			path: `import`,
			name: `import-projects`,
			component: Import,
			meta: {
				title: `Import Projects`
			}
		},
		// Retired into the unified Requests page: project suggestions are listed
		// there and decided one at a time on the page below. The old list URL
		// still lands on Requests, filtered to project suggestions.
		{
			path: `suggestions`,
			name: `project-suggestions`,
			redirect: {
				name: `requests`,
				query: {
					type: `project_suggestion`
				}
			}
		},
		{
			// No nav entry of its own: reached from a project suggestion's row
			// on the Requests page.
			path: `suggestions/:uuid`,
			name: `project-suggestion-detail`,
			component: ProjectSuggestionDetail,
			meta: {
				title: `Project Suggestion`
			}
		},
		{
			path: `settings`,
			name: `project-settings`,
			component: Settings,
			meta: {
				title: `Project Settings`
			}
		},
		{
			path: `new`,
			name: `add-project`,
			component: Add,
			meta: {
				title: `Add Project`
			}
		},
		{
			path: `:uuid`,
			name: `edit-project`,
			component: Edit,
			meta: {
				title: `Edit Project`
			}
		}
	]
};
